import React from 'react';
import {
  Box,
  Column,
  Row,
  SkeletonLoader,
} from '@chargify/custom-ui-components';

const PaymentProfileSkeleton = () => (
  <>
    <Box marginBottom={[3, 3, 7]}>
      <Row rowGap={[8, 8, 16]}>
        <Column span={[24, 7]}>
          <SkeletonLoader height={20} width={80} variant="primary" />
        </Column>
        <Column span={[24, 17]}>
          <SkeletonLoader height={150} variant="primary" />
        </Column>
      </Row>
    </Box>
    <Row rowGap={[8, 8, 16]}>
      <Column span={[24, 7]}>
        <SkeletonLoader height={20} width={60} variant="primary" />
      </Column>
      <Column span={[24, 17]}>
        <Box marginBottom={2}>
          <SkeletonLoader height={48} variant="primary" />
        </Box>
        <SkeletonLoader height={48} variant="primary" />
      </Column>
    </Row>
  </>
);

export default PaymentProfileSkeleton;
